export var GlobalActionType;
(function (GlobalActionType) {
    GlobalActionType["PROGRESS_CHANGE"] = "PROGRESS_CHANGE";
    GlobalActionType["DEFAULT_DATA_DISABLE"] = "DEFAULT_DATA_DISABLE";
    GlobalActionType["DEFAULT_DATA_ENABLE"] = "DEFAULT_DATA_ENABLE";
    GlobalActionType["LOADING"] = "LOADING";
    GlobalActionType["HIDE_MESSAGE_GLOBAL"] = "HIDE_MESSAGE_GLOBAL";
    GlobalActionType["SHOW_MESSAGE_GLOBAL"] = "SHOW_MESSAGE_GLOBAL";
    GlobalActionType["SHOW_NORMAL_MESSAGE_GLOBAL"] = "SHOW_NORMAL_MESSAGE_GLOBAL";
    GlobalActionType["SET_HEADER_TITLE"] = "SET_HEADER_TITLE";
    GlobalActionType["SHOW_TOP_LOADING"] = "SHOW_TOP_LOADING";
    GlobalActionType["HIDE_TOP_LOADING"] = "HIDE_TOP_LOADING";
    GlobalActionType["SHOW_MASTER_LOADING"] = "SHOW_MASTER_LOADING";
    GlobalActionType["HIDE_MASTER_LOADING"] = "HIDE_MASTER_LOADING";
    GlobalActionType["SHOW_SEND_FEEDBACK"] = "SHOW_SEND_FEEDBACK";
    GlobalActionType["HIDE_SEND_FEEDBACK"] = "HIDE_SEND_FEEDBACK";
    GlobalActionType["TEMP"] = "TEMP";
    GlobalActionType["CLEAR_ALL_GLOBAL"] = "CLEAR_ALL_GLOBAL";
    GlobalActionType["OPEN_POST_WRITE"] = "OPEN_POST_WRITE";
    GlobalActionType["CLOSE_POST_WRITE"] = "CLOSE_POST_WRITE";
    GlobalActionType["INIT_LOCALE"] = "INIT_LOCALE";
})(GlobalActionType || (GlobalActionType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/globalActionType.ts
// module id = 160
// module chunks = 50